import { render, staticRenderFns } from "./profile-header.vue?vue&type=template&id=775fb7ff&"
import script from "./profile-header.vue?vue&type=script&lang=js&"
export * from "./profile-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports